import React, { Component } from 'react';
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import IntlMessages from '../../helpers/IntlMessages';
import { Colxx } from '../../helpers/CustomBootstrap';
import Sessions from '../../components/Sessions';
import LiveStream from '../../components/LiveStream/index'

class ProgrammeView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      chosenActivity: null,
      chosenActivitySpeakers: [],
      topHeight: 0,
      showingRoomLink: ''
    }
  }


  _renderActivityAndSpeakerData(activity, actSpeakers, topHeight, roomLink) {
    // console.log("Boton Presionado en ProgrammeView")
    // console.log("Info de la actividad: ")
    // console.log(activity)
    // console.log("Speakers de la actividad: ")
    // console.log(actSpeakers)

    this.setState({
      chosenActivity: activity,
      chosenActivitySpeakers: actSpeakers,
      topHeight: topHeight
    })

    if (roomLink != undefined) {
      this.setState({ showingRoomLink: roomLink })
    }
  }

  goBackToProgramme() {
    this.setState({
      showingRoomLink: '',
      chosenActivity: null
    })
  }

  render() {
    const { showingRoomLink } = this.state

    return (
      <>
        {showingRoomLink.length == 0 ?
          <div>
            <Sessions clickAction={(activity, actSpeakers, topHeight, roomLink) => this._renderActivityAndSpeakerData(activity, actSpeakers, topHeight, roomLink)} />
          </div>
          :
          <>
            <Row>
              <Colxx xxs="12">
                <Button color="primary" onClick={() => this.goBackToProgramme()}>
                  <i className="simple-icon-arrow-left ml-2" />
                  <span className="d-inline-block"><IntlMessages id="button.back-to-programme" /></span>
                </Button>
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <LiveStream url={showingRoomLink} />
              </Colxx>
            </Row>
          </>
        }
      </>)
  }
}




export default ProgrammeView;
